import {
    FETCH_PIANOTECHCUSTOMER_LIST_STARTED,
    FETCH_PIANOTECHCUSTOMER_LIST_SUCCEEDED,
    FETCH_PIANOTECHCUSTOMER_LIST_FAILED,
    FIND_PIANOTECHCUSTOMER_STARTED,
    FIND_PIANOTECHCUSTOMER_SUCCEEDED,
    FIND_PIANOTECHCUSTOMER_FAILED,
    SAVE_PIANOTECHCUSTOMER_STARTED,
    SAVE_PIANOTECHCUSTOMER_SUCCEEDED,
    SAVE_PIANOTECHCUSTOMER_FAILED,
    RETURN_TO_PIANOTECHCUSTOMER_LIST,
    SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER,
    PIANOTECHCUSTOMER_MODIFIED,
    PIANOTECHCUSTOMER_VALIDATE,
    FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_SUCCEEDED,
    FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_FAILED,
    FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_STARTED,
    PIANOTECHCUSTOMER_VIEW_PIANO,
    PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE,
    PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO,
    PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE,
    PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE,
    PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
    PIANOTECHCUSTOMER_PIANO_ID_CHANGE,
    PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE,
    PIANOTECHCUSTOMER_SET_DATES,
    PIANOTECHCUSTOMER_UPDATE_TIMESLOTS,
    PIANOTECHCUSTOMER_HIDE_UNAVAILABLE_SLOTS,
    PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE,
    PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT,
    PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE,
    PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE,
} from '../actions/PianoTechCustomerActions';

import {
    FIND_PIANOTECHPIANO_SUCCEEDED,
} from '../actions/PianoTechPianoActions';

import {
    LOGIN_VALIDATE_USER_SUCCESS
} from '../actions/LoginActions';

import {
    MESSAGE_TYPE_CONFIRM,
    MESSAGE_TYPE_ERROR,
    MESSAGE_TYPE_INFO,
    VIEW_PIANOTECHCUSTOMER_LIST,
    VIEW_PIANOTECHCUSTOMER_UPDATE,
    MAINTENANCE_TYPE_COMPLETE,
} from '../app-constants';

const initialState = {
    pianoTechCustomerList: [],
    pianoTechCustomer: null,
    originalPianoTechCustomer: null,
    currentAppointment: null,
    originalAppointment: null,
    view: VIEW_PIANOTECHCUSTOMER_LIST,
    viewingPiano: false,
    pianoMaintenanceType: null,
    confirmDeletePiano: false,
    showAppointmentTable: false,
    currentPiano: null,
    currentPianoId: 0,
    showAppointment: false,
    weekStartDate: null,
    weekEndDate: null,
    timeslots: [],
    hideUnavailableSlots: false,
    selectedTechnicianId: 0,
    confirmDeleteAppointment: false,
};

const reducerOutput = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_PIANOTECHCUSTOMER_LIST_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechCustomer list.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechCustomerList: [],
                viewingPiano: false,
            }

        case FETCH_PIANOTECHCUSTOMER_LIST_SUCCEEDED:

            return {
                ...state,
                pianoTechCustomerList: action.pianoTechCustomerList,
                message: 'PianoTechCustomer list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHCUSTOMER_LIST_FAILED:

            return {
                ...state,
                pianoTechCustomerList: [],
                message: 'Error trying to retrieve PianoTechCustomer list.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case RETURN_TO_PIANOTECHCUSTOMER_LIST:

            return {
                ...state,
                pianoTechCustomer: null,
                originalPianoTechCustomer: null,
                message: '',
                view: VIEW_PIANOTECHCUSTOMER_LIST,
                showAppointment: false,
                showAppointmentTable: false,
            }

        case SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER:

            return {
                ...state,
                maintenanceType: action.maintenanceType,
                title: action.title,
                message: '',
                pianoTechCustomer: action.pianoTechCustomer,
            }

        case PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE:

            return {
                ...state,
                selectedTechnicianId: action.selectedTechnicianId,
            }

        case FIND_PIANOTECHCUSTOMER_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechCustomer.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechCustomer: null,
                maintenanceType: action.maintenanceType,
                title: action.title,
                viewingPiano: false,
                appointmentsFromDateRetrieved: false,
            }

        case FIND_PIANOTECHCUSTOMER_SUCCEEDED:

            return {
                ...state,
                pianoTechCustomer: action.pianoTechCustomer,
                originalPianoTechCustomer: action.originalPianoTechCustomer,
                message: 'PianoTechCustomer successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                view: VIEW_PIANOTECHCUSTOMER_UPDATE,
            }

        case FIND_PIANOTECHCUSTOMER_FAILED:

            return {
                ...state,
                pianoTechCustomer: null,
                message: 'Error trying to find PianoTechCustomer.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHCUSTOMER_MODIFIED:

            return {
                ...state,
                pianoTechCustomer: action.pianoTechCustomer,
                message: '',
            }

        case SAVE_PIANOTECHCUSTOMER_STARTED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_INFO,
            }

        case SAVE_PIANOTECHCUSTOMER_SUCCEEDED:

            return {
                ...state,
                pianoTechCustomer: action.pianoTechCustomer,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
                maintenanceType: MAINTENANCE_TYPE_COMPLETE,
            }

        case SAVE_PIANOTECHCUSTOMER_FAILED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHCUSTOMER_VALIDATE:

            return {
                ...state,
                message: action.message,
                messageType: action.messageType,
            }

        case FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechCustomer list by company.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechCustomerList: [],
            }

        case FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_SUCCEEDED:

            return {
                ...state,
                pianoTechCustomerList: action.pianoTechCustomerList,
                message: 'PianoTechCustomer list by company successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                confirmDeletePiano: false,
            }

        case FETCH_PIANOTECHCUSTOMER_LIST_BY_COMPANY_FAILED:

            return {
                ...state,
                pianoTechCustomerList: [],
                message: 'Error trying to retrieve PianoTechCustomer list by company.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case LOGIN_VALIDATE_USER_SUCCESS:

            return {
                ...state,
                pianoTechCustomerList: action.pianoTechCustomerList,
                selectedTechnicianId: action.selectedTechnicianId,
            }

        case PIANOTECHCUSTOMER_VIEW_PIANO:

            return {
                ...state,
                viewingPiano: action.viewingPiano,
            }

        case FIND_PIANOTECHPIANO_SUCCEEDED:

            return {
                ...state,
                viewingPiano: true,
            }

        case PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE:

            return {
                ...state,
                pianoMaintenanceType: action.pianoMaintenanceType,
            }

        case PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO:

            return {
                ...state,
                confirmDeletePiano: action.confirmDeletePiano,
            }

        case PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE:

            return {
                ...state,
                showAppointmentTable: action.showAppointmentTable,
                showAppointment: false,
            }

        case PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE:
            return {
                ...state,
                currentPiano: action.currentPiano,
            }

        case PIANOTECHCUSTOMER_APPOINTMENT_CHANGE:

            return {
                ...state,
                currentAppointment: action.currentAppointment,
            }

        case PIANOTECHCUSTOMER_PIANO_ID_CHANGE:

            return {
                ...state,
                currentPianoId: action.currentPianoId,
            }

        case PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE:

            return {
                ...state,
                showAppointment: action.showAppointment,
            }

        case PIANOTECHCUSTOMER_SET_DATES:

            return {
                ...state,
                weekStartDate: action.weekStartDate,
                weekEndDate: action.weekEndDate,
                timeslots: action.timeslots,
            }

        case PIANOTECHCUSTOMER_UPDATE_TIMESLOTS:

            return {
                ...state,
                timeslots: action.timeslots,
            }

        case PIANOTECHCUSTOMER_HIDE_UNAVAILABLE_SLOTS:

            return {
                ...state,
                hideUnavailableSlots: action.hideUnavailableSlots,
            }

        case PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT:

            return {
                ...state,
                confirmDeleteAppointment: action.confirmDeleteAppointment,
            }

        case PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE:

            return {
                ...state,
                weekStartDate: action.weekStartDate,
                weekEndDate: action.weekEndDate,
            }

        case PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE:

            return {
                ...state,
                originalAppointment: action.originalAppointment,
            }

        default:
            return state;
    }
}


export default reducerOutput;
